import React from 'react';
// components
import StatusList from 'src/components/status-list-component/status-list-component';
import { BagsJourneyType } from 'src/globals';
// images
const bags_in_van = require('../../images/bags_in_a_van.svg');
const bag_in_storage = require('../../images/bags_in_storage.svg');
// styles
const styles = require('./in-progress-status.scss');

declare var exponea: any;
interface IProps {
  trackingData: any;
  language: string;
  multiLang: any;
}

const IMAGE_MAP = {
  Collected: bags_in_van,
  InTransit: bags_in_van,
  InStorage: bag_in_storage,
  OutOfStorage: bag_in_storage,
  CheckedIn: bags_in_van,
  Downgraded: bags_in_van,
}


class InProgressComponent extends React.Component<IProps> {
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    exponea.track('tracking_screen', {
      page_name: 'Process',
      product_type: 'abc',
    });
  }

  public render() {
    const { multiLang, language, trackingData } = this.props;
    const { bagsJourney, completedTrackingStatus, processTrackingStatus } = trackingData;

    const title = multiLang[`${processTrackingStatus.titleDisplay}${language}`];
    const subTitle = multiLang[`${processTrackingStatus.subTitle}${language}`];
    const description = multiLang[`${processTrackingStatus.text}${language}`];

    const CurrentStep = bagsJourney.filter((i) => {
      if ((i.bagsJourneyStatus === 3)) {
        return i.bagsJourneyType
      }
    });

    const imgeSource = IMAGE_MAP[BagsJourneyType[CurrentStep[CurrentStep.length - 1].bagsJourneyType]];

    return (
      <div className={styles.mainContent}>
        <div className={styles.sectionWrapper}>
          <div className={styles.section}>
            <div className={styles.card}>
              <div className={styles.cardBody}>
                <h1 className={styles.heading}>
                  {title}
                </h1>

                <div className={styles.group}>
                  <div>
                    <img src={imgeSource} />
                    <h3 className={styles.subHeading}>
                      {subTitle}
                    </h3>
                    <p className={styles.description}>
                      {description}
                    </p>
                  </div>

                  <div>
                    <StatusList bagsJourney={bagsJourney} multiLang={multiLang} language={language} completedTrackingStatus={completedTrackingStatus} />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InProgressComponent;



// WEBPACK FOOTER //
// ./src/containers/in-progress/in-progress-status.component.tsx